export default {
  id: 218,
  title: 'Target #218 - 3D',
  url: 'https://cssbattle.dev/play/218',
  colors: ['#4C455B', '#8AB8B6'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{top:110;width:60;height:80;background:#8ab8b6}body,p[c]{background:#4c455b}p{position:fixed;margin:0}p[a]{left:62;border-radius:12px;box-shadow:72px 0 #8ab8b6,144px 0 #8ab8b6}p[b]{right:62;border-radius:0 12px 12px 0}p[c]{top:122;left:80;width:24;height:56;box-shadow:72px 0 #4c455b,144px 0 #4c455b,186px 0 #4c455b,222px 0 #4c455b',
}
